<app-page-hero-redesign
    [title]="'News & Articles'"
    [backgroundImage]="'/assets/img/redesign/solutions/hero-page-bg.png'"
    [breadcrumbs]="[
        { label: 'Home', link: '/' },
        { label: 'News & Articles' }
    ]">
</app-page-hero-redesign>
<app-news-list-redesign></app-news-list-redesign>
